import { Link } from "react-router-dom";

import { formatCurrency } from "@/toolbox/Money";

export interface GiftCardWalletItemProps {
  giftCardTransferItemId: string;
  imgUrl: string;
  title: string;
  personName: string;
  amount: number;
}

export const GiftCardWalletItem = ({
  giftCardTransferItemId,
  imgUrl,
  personName,
  amount,
}: GiftCardWalletItemProps) => {
  return (
    <Link
      className="relative block h-[190px] w-[322px] overflow-hidden rounded-xl"
      to={`/wallet/giftcards/${giftCardTransferItemId}`}
    >
      {/* Background Image */}
      <img
        className="absolute inset-0 h-full w-full object-cover"
        src={imgUrl}
        alt="Gift Card"
      />

      {/* Overlay gradient for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

      {/* Amount - Large and prominent at bottom left */}
      <div className="absolute bottom-4 left-4 z-10">
        <div className="flex items-start gap-1">
          <span className="text-h2 font-bold text-white drop-shadow-lg">
            {formatCurrency(amount, 0)}
          </span>
        </div>
      </div>

      {/* To/From info - Below amount */}
      <div className="absolute bottom-4 right-4 z-10 text-right">
        <span className="text-body1 font-medium text-white drop-shadow-lg">
          {personName}
        </span>
      </div>
    </Link>
  );
};

export default GiftCardWalletItem;
